import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-scoring',
  templateUrl: './scoring.component.html',
  styleUrls: ['./scoring.component.scss']
})
export class ScoringComponent implements OnInit {

  scoring: string;

  constructor(private r: Router) { }

  ngOnInit() {
    this.getParams();
  }


  getParams = () => {
    const url = window.location.href;
    let aux = '';
    aux = url.split('?s=')[1];
    this.scoring = aux.substr(0, aux.length);
  }

  /**
   * devuelve la frase en funcion del score recibido
   */
  getExpression = () => {
    switch (this.scoring) {
      case '0':
      case '1':
      case '2':
      case '3':
      case '4':
        return 'Intenta mantener buenos hábitos para mejorar tu Salud Financiera. ¡Tú puedes conseguirlo!';
      case '5':
      case '6':
        return 'Estás en el buen camino. Mantén buenos hábitos y tu Salud Financiera mejorará.';
      case '7':
      case '8':
        return 'Tu Salud Financiera parece estar en buena forma, ¡Sigue así!';
      case '9':
      case '10':
        return 'Aparentemente disfrutas de una buena Salud Financiera. ¡Lo estás haciendo genial!';
    }
  }


  goToUrl = () => {
    this.r.navigateByUrl('/home');
  }
}
